enum TipoDesconto {
    Dinheiro = 0,
    Percentual = 1,
    Faixa = 2
}

export default TipoDesconto;